import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseTypographyComponent } from '../base-typography.component';
@Component({
  selector: 'app-h3',
  template: '<h3 [ngClass]="ngClass"><ng-content></ng-content></h3>',
  styleUrls: ['./h3.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class H3Component extends BaseTypographyComponent {
}
